import { useLazyQuery, useMutation, useQuery, useSubscription } from "@apollo/client";
import bindOptions from "./bind-options";

export const dataModuleString = "data";

type Context = { context: { module?: string } } | undefined;

export const useDataQuery = bindOptions(
	useQuery,
	(c) =>
		({
			...c,
			context: { module: dataModuleString },
		} as Context)
);

export const useDataSubscription = bindOptions(useSubscription, (c) => ({ ...c, context: { module: dataModuleString } } as Context));

export const useLazyDataQuery = bindOptions(useLazyQuery, (c) => ({ ...c, context: { module: dataModuleString } } as Context));

export const useDataMutation = bindOptions(useMutation, (c) => ({
	onError: (e) => console.error(e),
	...c,
	context: { module: dataModuleString } as any,
}));
